import React, { useEffect } from 'react';
import BetaHeroSection from './components/BetaHeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import FourGuidesSection from './components/FourGuidesSection';
import BetaActionsSection from './components/BetaActionsSection';
import FeedbackSection from './components/FeedbackSection';
import SharedFooter from '../../components/ui/SharedFooter';

const TryDepthMeBeta = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="relative">
        <BetaHeroSection />
        <HowItWorksSection />
        <FourGuidesSection />
        <BetaActionsSection />
        <FeedbackSection />
      </main>
      <SharedFooter hideSocialLinks={true} />
    </div>
  );
};

export default TryDepthMeBeta;